import { Component, OnInit } from '@angular/core';
import { InputComponent } from '../input/input.component';

@Component({
  selector: 'harp-checkbox-group',
  templateUrl: './checkbox-group.component.html',
  styleUrls: ['./checkbox-group.component.css'],
})
export class CheckboxGroupComponent extends InputComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}

  getCheckboxConfig(config, option) {
    return {
      ...config,
      name: option.value,
      value: option.value,
      checkboxLabel: option.label,
    };
  }
}
